import React, { useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import { Grid } from "@mui/material";

import isOdd from "../../utilities/isOdd";
import variables from "../../assets/js/variables";
import { getTeamService } from "../../services/pagesRequestServices";

import Mamber from "./Mamber";
import Modal from "../../ui-kits/Modal";
import Close from "../../assets/media/icons/close";
import Linkedin from "../../assets/media/icons/linkedin";
import {
  toPersianNumber,
  toPersianNumberNotTag,
} from "../../utilities/persianNumber";
import HtmlContent from "../../components/general/misc/HtmlContent";
const { colors } = variables;

const Members = () => {
  const [membersData, changeMembersData] = useState([]);
  const [selectedMember, setSelectedMember] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);

  const getTeam = useCallback(() => {
    getTeamService().then(({ results }) => changeMembersData(results));
  }, []);

  useEffect(() => {
    getTeam();
  }, [getTeam]);

  const shuffleArray = (array) => {
    let currentIndex = array.length,
      randomIndex;

    while (currentIndex !== 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex],
      ];
    }
  };
  shuffleArray(membersData);
  return (
    <StyledMembers className="StyledMain">
      <Grid container spacing={2} className="container-members *grid*">
        {membersData?.map((item, index) => {
          return (
            <Grid
              item
              key={item.id + item.post}
              lg={3}
              md={4}
              sm={6}
              xs={12}
              className={` member-grid ${isOdd(index) ? "odd" : "even"}`}
            >
              <Mamber
                img={item.photo}
                first_name={item.first_name}
                last_name={item.last_name}
                post={item.post}
                click={() => {
                  setSelectedMember(item);
                  setModalOpen(true);
                }}
              />
              {isModalOpen && selectedMember && (
                <Modal>
                  <StyledDialog>
                    <div
                      className="screen"
                      onClick={() => setModalOpen(false)}
                    />
                    <div className="dialog_container  rounded bg-background text-white">
                      <div className="text-left">
                        <button
                          className="icon-close"
                          onClick={() => setModalOpen(false)}
                        >
                          <Close />
                        </button>
                      </div>
                      <div className="">
                        {window.innerWidth > 1000 ? (
                          <Grid container spacing={0}>
                            <Grid item xs={6} className="grid-img">
                              <div className="img-container">
                                <img src={selectedMember.photo} alt="" />
                              </div>
                            </Grid>
                            <Grid item xs={6}>
                              <span className="content">
                                <span className="main-content">
                                  <h3 className="name-member">
                                    {selectedMember.first_name}
                                    {selectedMember.last_name}
                                  </h3>
                                  <p className="post-member">
                                    {selectedMember.post}
                                  </p>
                                  <p className="description-member">
                                    <HtmlContent
                                      rawHtml={toPersianNumberNotTag(
                                        String(selectedMember?.description)
                                      )}
                                    />
                                  </p>
                                </span>
                                <span className="icons-sochial-member">
                                  <Linkedin />
                                </span>
                              </span>
                            </Grid>
                          </Grid>
                        ) : (
                          <div className="rispansive-size">
                            <div className="header-rispansive-size">
                              <span className="img-container-rispansive-size">
                                <img src={selectedMember.photo} alt="" />
                              </span>
                              <span className="person-item-rispansive-size">
                                <h3 className="name-member-rispansive-size">
                                  {selectedMember.first_name}{" "}
                                  {selectedMember.last_name}
                                </h3>
                                <p className="post-member-rispansive-size">
                                  {selectedMember.post}
                                </p>
                              </span>
                            </div>
                            <span className="content-rispansive-size">
                              <p className="description-member-rispansive-size">
                                <HtmlContent
                                  rawHtml={toPersianNumberNotTag(
                                    String(selectedMember?.description)
                                  )}
                                />
                              </p>
                              <span className="icons-sochial-member">
                                <Linkedin />
                              </span>
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </StyledDialog>
                </Modal>
              )}
            </Grid>
          );
        })}
      </Grid>
    </StyledMembers>
  );
};

export default Members;
const StyledMembers = styled.div`
  //new add test
  max-height: 75vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: scroll;
  margin-bottom: 5px;
  bottom: 0;
  top: 0;
  position: absolute;
  padding: 0;
  .container-members {
    width: calc(100% - 12rem);
    display: flex;
    align-items: center;
    margin: 0 auto;
    justify-content: center;
    min-height: fit-content;
    max-height: 70vh;
  }
  .even {
    .container-member {
      :hover {
        border: 2px solid #475cfc;
      }
      background: ${colors.whiteSmoke};
      img {
        border: 4px solid #475cfc;
      }
      h3 {
        color: #475cfc;
      }
      p {
        color: #535353;
      }
    }
  }
  .odd {
    .container-member {
      :hover {
        border: 2px solid #00ebb5;
      }
      background: ${colors.darkBlue};
      img {
        border: 4px solid #00ebb5;
      }
      h3 {
        color: #00ebb5;
      }
      p {
        color: ${colors.text};
      }
    }
  }
  .animate {
    width: 100%;
  }
  @media (max-width: 1200px) {
    align-items: flex-start !important;
  }
  @media (max-width: 600px) {
    max-height: initial !important;
    max-height: initial !important;
    bottom: auto;
    top: auto;
    position: static;
    .container-members {
      width: calc(100% - 64px);
      max-height: initial !important;
      max-height: initial !important;
      overflow: scroll;
    }
  }
`;
const StyledDialog = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1003;
  .icon-close {
    position: absolute;
    left: 12px;
    top: 12px;
    border: none;
    outline: none;
    background: ${colors.background};
    border: 2px solid white;
    border-radius: 50%;
    padding: 8px;
    background: none;
    @media (max-width: 600px) {
      padding: 6px;
      left: 10px;
      top: 10px;
    }
    @media (max-width: 300px) {
      padding: 2px;
    }
    svg {
      width: 26px;
      height: 26px;
      @media (max-width: 768px) {
        width: 30px;
        height: 30px;
      }
      path {
        stroke: ${colors.text};
        fill: ${colors.text};
      }
    }
  }

  .screen {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    background: rgba(255, 255, 255, 0.01);
    backdrop-filter: blur(1px);
  }

  .dialog_container {
    min-width: calc(100% - 12rem);
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 2rem;
    @media (max-width: 600px) {
      padding: 1rem 1rem 0;
    }
    .text-left {
      text-align: left;
    }
    .grid-img {
      display: flex;
      align-items: center !important;
    }
  }
  //768 => 2
  //600 => 1
  @media (max-width: 600px) {
    .dialog_container {
      width: 100vw;
      height: 100vh;
    }
  }
  .img-container {
    width: 100%;
    img {
      width: 90%;
      border-top-right-radius: 20%;
    }
  }

  .content {
    width: 100%;
    height: 100%;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    margin-right: 0;
    .name-member {
      font-size: 43px;
      margin-right: 10px;
      color: #00ebb5;
      margin-bottom: 5px;
      width: 100%;
    }
    .post-member {
      color: ${colors.text};
      font-size: 29px;
      margin-right: 10px;
      width: 100%;
    }
    .description-member {
      color: ${colors.text};
      font-size: 16px;
      width: 100%;
      height: 100%;
      max-height: 50vh;
      overflow: scroll;
    }
  }
  .icons-sochial-member {
    svg {
      fill: white !important;
      stroke: white !important;
      width: 45px;
      @media (max-width: 1500px) {
        width: 40px;
      }
      @media (max-width: 1200px) {
        width: 35px;
      }
      @media (max-width: 600px) {
        width: 30px;
      }
    }
    path {
      fill: white !important;
      stroke: white !important;
    }
  }
  .rispansive-size {
    .header-rispansive-size {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      @media (max-width: 600px) {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
    }
    .img-container-rispansive-size {
      margin-bottom: 10px;
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      @media (max-width: 600px) {
        width: 70%;
      }
      img {
        width: 90%;
        height: auto;
        border-top-right-radius: 20%;
        @media (max-width: 600px) {
          width: 100%;
        }
      }
    }
    .person-info-rispansive-size {
      width: 50%;
      display: flex;
      flex-direction: column;
      @media (max-width: 600px) {
        width: 100%;
        margin: 1rem auto 0;
      }
    }
    .name-member-rispansive-size {
      font-size: 32px;
      margin-right: 10px;
      color: #00ebb5;
      margin-bottom: 0;
      width: 100%;
    }
    .post-member-rispansive-size {
      color: ${colors.text};
      font-size: 20px;
      margin-right: 10px;
      width: 100%;
    }
    .content-rispansive-size {
      display: flex;
      flex-direction: column;
      width: 95% !important;
      margin: 8px auto 0;
      color: ${colors.text};
      font-size: 16px;
    }
    .description-member-rispansive-size {
      max-height: 50vh;
      height: 100%;
      overflow: scroll;
      margin: 0;
    }
  }
`;
